<div class="testimonials-bg">
  <section class="testimonials-section container py-5">
    <div class="glass-panel-container testimonials-glass">
      <div class="row align-items-center">
 
        <!-- Left Text Section -->
        <div class="col-lg-4 col-md-5 testimonials-text">
          <h2 class="testimonials-heading">Testimonials</h2>
          <p class="testimonials-subheading">
            Discover the fresh stories of <br>
            Kalpita Technologies.
          </p>
        </div>
 
        <!-- Right Image Section -->
        <div class="col-lg-8 col-md-7 text-center">
          <video src="../../../../assets/gallery-page/testimonials/clienttestimonial.webm" class="img-fluid testimonials-image"
            autoplay loop muted playsinline disablePictureInPicture>
          </video>
        </div>
 
      </div>
    </div>
  </section>
</div>
 
<section class="video-testimonials-section py-5">
    <div class="container">
        <div class="row g-4 align-items-center">
            <!-- Testimonial Text -->
            <div class="col-lg-5 pe-5">
                <div class="testimonial-content">
                    <h2 class="heading-two">
                        Video<br />Testimonials
                    </h2>
 
                    <!-- Selected Testimonial -->
                    <div class="selected-testimonial">
                        <h4 class="testimonial-name">
                            {{ selectedPlaylist.testimonial.name }}
                        </h4>
                        <p class="testimonial-designation">
                            {{ selectedPlaylist.testimonial.designation }} {{ selectedPlaylist.testimonial.company }}
                        </p>
                        <p class="testimonial-text">
                            {{ selectedPlaylist.testimonial.content }}
                        </p>
                    </div>
                </div>
            </div>
 
            <!-- Video Player -->
            <div class="col-lg-7">
                <div class="video-player-container">
                    <div class="main-video-wrapper position-relative rounded-4 overflow-hidden">
                        <iframe [src]="safeVideoUrl" class="w-100 h-100 border-0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                       
                        <!-- Play Button Overlay -->
                        <div class="video-play-overlay">
                            <div class="play-button-circle">
                                <i class="bi bi-play-fill"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
 
        <!-- Video Thumbnails Carousel -->
        <div class="row mt-5">
            <div class="col-12">
                <div class="video-playlist">
                    <!-- Navigation Container -->
                    <div class="video-carousel-container position-relative">
                        <!-- Previous Arrow -->
                        <button
                            class="carousel-arrow carousel-arrow-prev"
                            [class.disabled]="currentVideoPage === 0"
                            (click)="prevVideoPage()"
                            [disabled]="currentVideoPage === 0">
                            <i class="bi bi-chevron-left"></i>
                        </button>
 
                        <!-- Video Thumbnails -->
                        <div class="playlist-scroll-container">
                            <div class="playlist-scroll">
                                <div *ngFor="let vid of pagedVideos; let j = index; trackBy: trackByVideo"
                                    class="video-thumbnail-card"
                                    [class.active]="selectedVideo.id === vid.id"
                                    (click)="selectVideo(vid)">
                                    <div class="thumbnail-wrapper">
                                        <img [src]="vid.thumbnail" [alt]="vid.title" class="thumbnail-image" />
 
                                        <!-- Play Button Overlay -->
                                        <div class="play-overlay">
                                            <div class="play-btn-circle">
                                                <i class="bi bi-play-fill"></i>
                                            </div>
                                        </div>
                                    </div>
 
                                    <div class="video-info">
                                        <h6 class="video-title">{{ vid.title }}</h6>
                                        <p class="video-designation">{{ selectedPlaylist.testimonial.designation }} {{ selectedPlaylist.testimonial.company }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
 
                        <!-- Next Arrow -->
                        <button
                            class="carousel-arrow carousel-arrow-next"
                            [class.disabled]="currentVideoPage >= totalVideoPages - 1"
                            (click)="nextVideoPage()"
                            [disabled]="currentVideoPage >= totalVideoPages - 1">
                            <i class="bi bi-chevron-right"></i>
                        </button>
                    </div>
 
                    <!-- Carousel Dots (Playlist Indicators) -->
                    <div class="carousel-dots">
                        <span *ngFor="let playlist of playlists; let i = index"
                            class="dot"
                            [class.active]="currentPlaylistIndex === i"
                            (click)="selectPlaylistByIndex(i)">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
 
<section class="written-testimonial-section written-testimonial-wrapper">
  <h2 class="written-heading">Written Testimonials</h2>
 
  <!-- Reusing your existing component as-is -->
 <app-clients-testimonal></app-clients-testimonal>
</section>